import { render, staticRenderFns } from "./PlayerHead.vue?vue&type=template&id=5fa6bb7a&scoped=true&"
import script from "./PlayerHead.vue?vue&type=script&lang=ts&"
export * from "./PlayerHead.vue?vue&type=script&lang=ts&"
import style0 from "./PlayerHead.vue?vue&type=style&index=0&id=5fa6bb7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa6bb7a",
  null
  
)

export default component.exports